<template>
  <div>
    <DarkModeSwitcher />
    <div class="container sm:px-10">
      <div class="block xl:grid grid-cols-2 gap-4">
        <!-- BEGIN: Login Info -->
        <div class="hidden xl:flex flex-col min-h-screen">
          <a href="" class="-intro-x flex items-center pt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="120"
              height="29.944"
              viewBox="0 0 177 29.944"
              fill="white"
            >
              <g transform="translate(-478.85 106.927)">
                <g transform="translate(478.85 -106.927)">
                  <g>
                    <path
                      d="M490.888-81.862a7.169,7.169,0,0,1-7.162-7.16v-8.155h2.687v8.155a4.481,4.481,0,0,0,4.475,4.476,4.481,4.481,0,0,0,4.475-4.476V-99.364H478.85v-7.563h24.077v2.686H481.537v2.192H498.05v13.027A7.169,7.169,0,0,1,490.888-81.862Z"
                      transform="translate(-478.85 106.927)"
                    ></path>
                  </g>
                  <g transform="translate(0 4.879)">
                    <path
                      d="M490.888-77.249A12.054,12.054,0,0,1,478.85-89.287v-8.155h2.687v8.155a9.361,9.361,0,0,0,9.35,9.351,9.363,9.363,0,0,0,9.351-9.351v-13.027h2.687v13.027A12.054,12.054,0,0,1,490.888-77.249Z"
                      transform="translate(-478.85 102.314)"
                    ></path>
                  </g>
                </g>
                <g transform="translate(511.969 -100.868)">
                  <path
                    d="M512.31-84.306a8.4,8.4,0,0,1-2.145-6.183v-10.459h3.441v10.327q0,5.456,4.713,5.455,4.686,0,4.687-5.455v-10.327H526.4v10.459a8.429,8.429,0,0,1-2.131,6.183,8.012,8.012,0,0,1-5.97,2.158A8.054,8.054,0,0,1,512.31-84.306Z"
                    transform="translate(-510.165 101.212)"
                  ></path>
                  <path
                    d="M546.577-100.153a6.1,6.1,0,0,1,2.74,2.277,6.368,6.368,0,0,1,.953,3.521,6.388,6.388,0,0,1-.953,3.509,6.077,6.077,0,0,1-2.74,2.29,10.262,10.262,0,0,1-4.2.794H538.2v5.348h-3.443v-18.535h7.625A10.262,10.262,0,0,1,546.577-100.153Zm-.94,8.525a3.323,3.323,0,0,0,1.164-2.728,3.322,3.322,0,0,0-1.164-2.727,5.29,5.29,0,0,0-3.416-.953H538.2v7.36h4.024A5.29,5.29,0,0,0,545.637-91.627Z"
                    transform="translate(-508.748 101.212)"
                  ></path>
                  <path
                    d="M559.393-82.743a8.648,8.648,0,0,1-3.163-1.615l1.191-2.675a9.373,9.373,0,0,0,2.794,1.47,10.144,10.144,0,0,0,3.322.569,5.745,5.745,0,0,0,3.085-.662,2.006,2.006,0,0,0,1.019-1.747,1.7,1.7,0,0,0-.569-1.311,4,4,0,0,0-1.444-.807q-.874-.292-2.383-.662a27.788,27.788,0,0,1-3.429-1.006,5.639,5.639,0,0,1-2.25-1.576,4.241,4.241,0,0,1-.94-2.9,4.948,4.948,0,0,1,.834-2.794,5.653,5.653,0,0,1,2.515-2,10.2,10.2,0,0,1,4.117-.741,13.313,13.313,0,0,1,3.337.424,9.215,9.215,0,0,1,2.832,1.217l-1.085,2.675a10.754,10.754,0,0,0-2.543-1.086,9.53,9.53,0,0,0-2.568-.37,5.367,5.367,0,0,0-3.032.689,2.125,2.125,0,0,0-.992,1.826,1.651,1.651,0,0,0,.569,1.3,4.111,4.111,0,0,0,1.443.794q.874.292,2.384.662a25.127,25.127,0,0,1,3.388.993,5.805,5.805,0,0,1,2.264,1.575,4.155,4.155,0,0,1,.939,2.86,4.888,4.888,0,0,1-.833,2.78,5.67,5.67,0,0,1-2.529,1.986,10.294,10.294,0,0,1-4.131.74A14.139,14.139,0,0,1,559.393-82.743Z"
                    transform="translate(-507.511 101.198)"
                  ></path>
                  <path
                    d="M584.717-90.171l-2.938,3.018v4.739h-3.443v-18.535h3.443v9.506l9.16-9.506h3.867l-7.785,8.289,8.261,10.246h-4.024Z"
                    transform="translate(-506.237 101.212)"
                  ></path>
                  <path
                    d="M601.453-100.948H604.9v18.535h-3.443Z"
                    transform="translate(-504.906 101.212)"
                  ></path>
                  <path
                    d="M614.093-100.948h3.443v15.623h9.691v2.912H614.093Z"
                    transform="translate(-504.177 101.212)"
                  ></path>
                  <path
                    d="M633.791-100.948h3.443v15.623h9.69v2.912H633.791Z"
                    transform="translate(-503.043 101.212)"
                  ></path>
                </g>
              </g>
            </svg>
            <!--            <span class="text-white text-lg ml-3">-->
            <!--              Mid<span class="font-medium">One</span>-->
            <!--            </span>-->
          </a>
          <div class="my-auto">
            <img
              alt="upskill-hero image"
              class="-intro-x w-1/2 -mt-16 "
              src="https://upskill.com.bd/img/banner_image.1d210a4d.png"
            />
            <div
              class="-intro-x text-white font-medium text-4xl leading-tight mt-10"
            >
              Sign in to your Trainer Account
            </div>

            <div
              class="-intro-x mt-5 leading-loose text-md text-white dark:text-gray-500 list-disc"
            >
              <li>Manage workshop sales</li>
              <li>View reports from your dashboard</li>
            </div>
            <div class="-intro-x mt-5 text-md text-gray-500 dark:text-gray-500">
              <!-- If you have not signed up already, visit <a class="text-pink-500" href="https://upskill.com.bd">Upskill</a> -->
              For any queries, contact
              <a class="text-pink-500" href="mailto:tasfia.upskill@gmail.com"
                >tasfia.upskill@gmail.com</a
              >
            </div>
          </div>
        </div>
        <!-- END: Login Info -->
        <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
          <div
            class="my-auto mx-auto xl:ml-20 bg-white xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto"
          >
            <h2
              class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left"
            >
              <img
                alt="upskill-hero image"
                class="-intro-x w-1/2 mx-auto md:hidden"
                src="https://upskill.com.bd/img/banner_image.1d210a4d.png"
              />
              Enter your password
            </h2>
            <div class="intro-x mt-2 text-gray-500 xl:hidden text-center">
              Password Reset: Enter your password
            </div>
            <div class="intro-x mt-8">
              <input
                type="password"
                class="intro-x login__input input input--lg border border-gray-300 block"
                placeholder="Password"
                v-model="model.password"
              />
            </div>
            <div class="intro-x mt-8">
              <input
                type="password"
                class="intro-x login__input input input--lg border border-gray-300 block"
                placeholder="Confirm Password"
                v-model="model.confirmPassword"
              />
            </div>
            <div
              class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4"
            >
              <div class="flex items-center mr-auto"></div>
              <a href="#" @click="$router.push({ name: 'login' })"
                >Go back to login page</a
              >
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
              <button
                class="button button--lg w-full xl:w-32 text-white bg-theme-1 xl:mr-3 align-top loading"
                @click="changePassword"
              >
                Submit
              </button>
              <button
                class="button h-8 w-full xl:w-32 xl:mr-3 align-top"
                v-if="btnLoading"
              >
                <LoadingIcon icon="oval" color="black" />
                Please wait
              </button>
            </div>
            <div
              class="intro-x mt-10 xl:mt-24 text-gray-700 dark:text-gray-600 text-center xl:text-left"
            >
              By signin up, you agree to our <br />
              <a class="text-theme-1 dark:text-theme-10" href=""
                >Terms and Conditions</a
              >
              &
              <a class="text-theme-1 dark:text-theme-10" href=""
                >Privacy Policy</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DarkModeSwitcher from '@/components/DarkModeSwitcher'
import Toastify from 'toastify-js'

export default {
  components: {
    DarkModeSwitcher,
  },
  data() {
    return {
      model: {},
      btnLoading: false,
    }
  },
  methods: {
    alertMsg(msg) {
      Toastify({
        text: msg,
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: 'bottom',
        position: 'center',
        backgroundColor: '#1574e3',
        stopOnFocus: true,
      }).showToast()
    },
    alertInvalidRequest() {
      Toastify({
        text: 'Session expired, please try again!',
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: 'bottom',
        position: 'center',
        backgroundColor: '#e73030',
        stopOnFocus: true,
      }).showToast()
    },
    alertValidRequest() {
      Toastify({
        text: 'Your password has been changed successfully!!',
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: 'bottom',
        position: 'center',
        backgroundColor: '#01a744',
        stopOnFocus: true,
      }).showToast()
    },
    changePassword() {
      this.btnLoading = true
      if (
        this.model.password < 9 ||
        this.model.password !== this.model.confirmPassword
      ) {
        this.alertMsg(
          'Password must be at least 8 characters long and both fields must match!'
        )
        // this.ErrorAlert(
        //     "Must must be at least 8 characters long and both fields must match!"
        // );
      } else {
        this.btnLoading = true
        this.$upskill
          .pwFinal(this.request_id, this.model.password)
          .then(() => {
            this.btnLoading = false
            this.alertValidRequest()
            // this.SuccessAlert("Password changed successfully!");
            this.$router.push({ name: 'login' })
          })
          .catch(() => {
            this.btnLoading = false
            this.alertInvalidRequest()
          })
      }
    },
  },
  mounted() {
    cash('body')
      .removeClass('app')
      .addClass('login')
    this.request_id = this.$route.query.id
    this.$upskill
      .pwCheck(this.request_id)
      .then(() => {})
      .catch(() => {
        this.$router.push({ name: 'login' })
      })
  },
}
</script>
